module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('a', {
    staticClass: "sgc-3",
    attrs: {
      "href": "#/Text/01_section"
    }
  }, [_vm._v("JUSTINE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/02_note"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/05_part1"
    }
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_part2"
    }
  }, [_vm._v("Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/07_part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/08_part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    staticClass: "sgc-3",
    attrs: {
      "href": "#/Text/11_section02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BALTHAZAR")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_part1#part1-01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_part2VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_part2VI#vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_part3X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_part3X#x",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_part4XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_part4XII#xii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    staticClass: "sgc-3",
    attrs: {
      "href": "#/Text/32_section03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MOUNTOLIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/34_note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/36_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/37_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/38_III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/39_IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/40_V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/41_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/42_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/43_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/44_IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/45_X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/46_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/47_XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/48_XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/49_XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/50_XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/51_XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    staticClass: "sgc-3",
    attrs: {
      "href": "#/Text/52_section04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLEA")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/55_I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/60_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/61_III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/62_IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/63_V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/64_VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/65_VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/66_VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/67_1X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal sgc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/biography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of Lawrence Durrell")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f7dd597","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0